var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ascSortedHomePageData.length)?_c('div',{staticClass:"c-menu__windows",style:(_vm.windowsPositionStyles)},_vm._l((_vm.ascSortedHomePageData),function(section,index){return _c('SideMenuSlide',{key:index,class:{
      current: !(index > 0),
      active: index === _vm.selectedSection,
    },attrs:{"sectionAttributes":section.attributes},nativeOn:{"click":function($event){_vm.selectedSection = index}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }